import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import ResourceRelationshipsDisplay from './ResourceRelationshipsDisplay';
import React from 'react';

const Types = {
  RESOURCE: 'resource'
};

const classTarget = {
  canDrop(props, monitor) {
    const item = monitor.getItem();
    if (props.isReadOnly) return false;
    if (item.resourceId === props.source) return false;
    if (props.values && props.values.includes(item.resourceId)) return false;
    return true;
  },
  drop(props, monitor) {
    const item = monitor.getItem();
    props.onMove(item.resourceId);
  }
};

function collectTarget(connect, monitor) {
  return {
    canDrop: monitor.canDrop(),
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

class ResourceDropRelationshipsDisplay extends React.Component {

  render() {

    const { connectDropTarget, isOver, canDrop, isReadOnly } = this.props;

    return connectDropTarget(
      <div style={{ height: '100%' }}>
        <ResourceRelationshipsDisplay {...this.props} highlight={isOver && canDrop && !isReadOnly} />
      </div>
    );
  }
}

ResourceDropRelationshipsDisplay.propTypes = {
  isReadOnly: PropTypes.bool,
  defaultPros: PropTypes.string,
  connectDropTarget: PropTypes.func,
  onMove: PropTypes.func.isRequired
};

export default DropTarget(Types.RESOURCE, classTarget, collectTarget)(ResourceDropRelationshipsDisplay);